import { jsx } from "react/jsx-runtime";
import React from "react";
var arrow_right_default = (prefix = "") => {
  return [/* @__PURE__ */ jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m20.0008 12.0001-8-8.001-1.4143 1.414L16.1727 11H4v2h12.1723l-5.5868 5.5866 1.4141 1.4142 8.0012-8.0007z" })];
};
export {
  arrow_right_default as default
};
